import { PublicDeliveryInfo } from '../types/store';

export const WHATSAPP_SALUD_EN_CASA = '51984153429';
export const WHATSAPP_DIAGNOSTICO_EXPRESS = '51979370177';

type ServiceWhatsAppMessageParams = {
  userName: string;
  deliveryInfo: PublicDeliveryInfo;
  serviceName: string;
  serviceDetail?: string;
};

export function buildServiceWhatsAppMessage({
  userName,
  deliveryInfo,
  serviceName,
  serviceDetail,
}: ServiceWhatsAppMessageParams): string {
  const address = deliveryInfo.address.trim() || 'Sin direccion registrada';
  const lines = [
    'Hola, quisiera solicitar un servicio:',
    '',
    `Servicio: ${serviceName}`,
  ];

  if (serviceDetail) {
    lines.push(`Detalle: ${serviceDetail}`);
  }

  lines.push(
    '',
    `Nombre: ${userName}`,
    `Direccion: ${address}`,
    `Telefono: ${deliveryInfo.phone}`,
  );

  if (deliveryInfo.reference.trim()) {
    lines.push(`Referencia: ${deliveryInfo.reference.trim()}`);
  }

  return lines.join('\n');
}

export function buildWhatsAppUrl(phone: string, message: string): string {
  const digits = phone.replace(/\D/g, '');
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(phone: string, message: string): void {
  window.open(buildWhatsAppUrl(phone, message), '_blank', 'noopener,noreferrer');
}
